export const createBookingId = 'new-booking';
export const oneMinuteInMs = 60000;

